import { HandCoins, Handshake, LayoutDashboard, LifeBuoy } from "lucide-react";

export const navigation = [
	{
		name: "Dashboard",
		href: "/dashboard",
		icon: LayoutDashboard,
	},
	{
		name: "Partners",
		href: "/partners",
		icon: Handshake,
	},
	{
		name: "Finances",
		href: "/finances",
		icon: HandCoins,
	},
	{
		name: "Support",
		href: "/support",
		icon: LifeBuoy,
	},
];
